import { create } from "zustand";
import { Profile } from "../models/Profile";
import { Project, Tag } from "../models/Project";
import {
  addContactToProject,
  createProject,
  deleteProject,
  getAllProjects,
  getProject,
  updateProject,
} from "../repositories/ProjectsRepository";
import { Contact } from "../models/Contact";
import { Invoice } from "../models/Invoice";
import {
  createInvoice,
  deleteInvoice,
  downloadInvoicesZip,
  getAllInvoices,
  getInvoice,
  importInvoice,
  updateInvoice,
  uploadFile,
} from "../repositories/InvoiceRepository";
import { InvoiceCreateDto } from "../models/dto/CreateInvoiceDto";

export interface InvoiceStore {
  invoices?: Invoice[];
  fetchInvoices: (user: Profile) => Promise<Invoice[] | undefined>;
  fetchInvoice: (
    user: Profile,
    invoiceId: number
  ) => Promise<Invoice | undefined>;
  createInvoice: (user: Profile, invoice: InvoiceCreateDto) => Promise<Invoice | undefined>;
  addInvoice: (user: Profile, invoice: Invoice) => Promise<Invoice | undefined>;
  editInvoice: (
    user: Profile,
    invoice: Invoice,
    invoiceId: number
  ) => Promise<number | undefined>;
  removeInvoice: (
    user: Profile,
    invoiceId: number
  ) => Promise<number | undefined>;
  addFileToInvoice: (
    user: Profile,
    file: File,
    invoiceId: number
  ) => Promise<number | undefined>;
  downloadInvoices: (
    user: Profile,
    ids: number[]
  ) => Promise<void>;
}

export const useInvoice = create<InvoiceStore>((set) => ({
  fetchInvoices: (user) => {
    return getAllInvoices(set, user);
  },
  fetchInvoice: (user, invoiceId) => {
    return getInvoice(user, invoiceId);
  },
  addInvoice: (user, invoice) => {
    return importInvoice(user, invoice);
  },
  createInvoice: (user, invoice) => {
    return createInvoice(user, invoice);
  },
  editInvoice: (user, invoice, invoiceId) => {
    return updateInvoice(user, invoice, invoiceId);
  },
  removeInvoice: (user, invoiceId) => {
    return deleteInvoice(user, invoiceId);
  },
  addFileToInvoice: (user, file, invoiceId) => {
    return uploadFile(user, file, invoiceId);
  },
  downloadInvoices: async (user, ids) => {
    await downloadInvoicesZip(user, ids);
  },
}));
